/* React */
import React, { useState, useEffect } from "react";

/* Ionic */
import { IonInput } from "@ionic/react";

/* Stylesheet */
import styles from "./ValueInput.module.scss";

/* Interfaces */
interface ValueInputProps {
  className?: string;
  label: string;
  value: number;
  min: number;
  max: number;
  isLower: boolean;
  disabled?: boolean;
  onChange: (value: number) => void;
}

const ValueInput: React.FC<ValueInputProps> = ({
  className,
  label,
  value,
  min,
  max,
  isLower,
  disabled,
  onChange,
}) => {
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const [tmpValue, setTmpValue] = useState<number>(value);

  useEffect(() => {
    setTmpValue(value);
  }, [value]);

  const handleInputChange = (e: CustomEvent) => {
    const rawValue = e.detail.value;
    const parsedValue = parseFloat(rawValue);

    if (!isNaN(parsedValue)) {
      setTmpValue(parsedValue);

      if (timeoutId) clearTimeout(timeoutId);

      const newTimeoutId = setTimeout(() => {
        const clampedValue = isLower
          ? Math.max(min, Math.min(parsedValue, max))
          : Math.min(max, Math.max(parsedValue, min));

        setTmpValue(clampedValue);
        onChange(clampedValue);
      }, 1000);

      setTimeoutId(newTimeoutId);
    }
  };

  return (
    <div
      className={`${styles.value_input} ${
        disabled ? styles.disabled : styles[className ?? ""]
      }`}
    >
      <div className={styles.label}>{label}</div>
      <IonInput
        className={styles.input}
        type="number"
        value={tmpValue}
        disabled={disabled}
        onIonInput={handleInputChange}
      />
    </div>
  );
};

export default ValueInput;
